export class FormTypeTransformer {

    static transform(obj) {
  
      const data = obj.hasOwnProperty('attributes') ? obj.attributes : obj;
  
      return Object.assign({id: obj.id}, data);
    }
  }
  


// WEBPACK FOOTER //
// ./src/helpers/forms/form-type.transformer.js